const intlCache: Record<string, Intl.DateTimeFormat> = {};

export function formatDate(
  inputDate: Date | string,
  locale = 'en-GB',
  options?: Intl.DateTimeFormatOptions
) {
  const key = [locale, options && Object.entries(options)].toString();

  let formatter = intlCache[key];

  if (!formatter) {
    formatter = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      ...options,
    });
    intlCache[key] = formatter;
  }

  return formatter.format(new Date(inputDate));
}

export function formatDateRange(
  earliestDate: Date | string,
  latestDate: Date | string,
  locale = 'en-GB',
  options?: Intl.DateTimeFormatOptions
) {
  const key = [locale, options && Object.entries(options)].toString();

  let formatter = intlCache[key];

  if (!formatter) {
    formatter = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      ...options,
    });
    intlCache[key] = formatter;
  }

  return formatter.formatRange(new Date(earliestDate), new Date(latestDate));
}
